import { MonthlyOverviewMetricKey } from "../../types/monthlyOverview.type";

// Единый источник правды о колонках расшифровки:
// используется и таблицей в модалке, и экспортом в Excel.

export type MetricColumnType = "text" | "tag" | "qty" | "currency";

export interface MetricColumn {
  key: string;
  title: string;
  type: MetricColumnType;
  width?: number;
  ellipsis?: boolean;
}

export const METRIC_TITLES: Record<MonthlyOverviewMetricKey, string> = {
  receivedFromClients: "Получено от клиентов",
  producedGoods: "Произведено товаров",
  sales: "Продажи",
};

/** Поле строки, по которому считается денежный итог метрики (UZS). */
export const METRIC_VALUE_FIELD: Record<MonthlyOverviewMetricKey, string> = {
  receivedFromClients: "amountUZS",
  producedGoods: "totalUZS",
  sales: "totalUZS",
};

export const METRIC_COLUMNS: Record<MonthlyOverviewMetricKey, MetricColumn[]> = {
  receivedFromClients: [
    { key: "date", title: "Дата", type: "text", width: 140 },
    { key: "clientName", title: "Клиент", type: "text" },
    { key: "cashboxName", title: "Касса", type: "text" },
    { key: "currency", title: "Валюта", type: "tag", width: 90 },
    { key: "amount", title: "Сумма", type: "currency" },
    { key: "amountUZS", title: "В UZS", type: "currency" },
    { key: "description", title: "Описание", type: "text", ellipsis: true },
  ],
  producedGoods: [
    { key: "produceName", title: "Продукция", type: "text" },
    { key: "unitOfMeasurement", title: "Ед.", type: "text", width: 90 },
    { key: "quantity", title: "Кол-во", type: "qty" },
    { key: "minPrice", title: "Min цена, UZS", type: "currency" },
    { key: "totalUZS", title: "Стоимость, UZS", type: "currency" },
  ],
  sales: [
    { key: "date", title: "Дата", type: "text", width: 140 },
    { key: "clientName", title: "Клиент", type: "text" },
    { key: "name", title: "Наименование", type: "text" },
    { key: "kind", title: "Вид", type: "tag", width: 110 },
    { key: "quantity", title: "Кол-во", type: "qty" },
    { key: "priceUZS", title: "Цена, UZS", type: "currency" },
    { key: "totalUZS", title: "Сумма, UZS", type: "currency" },
  ],
};
